module.exports = __webpack_public_path__ + "img/map.f6fe3c8d.png";